import axios from './axios';
import { PAGINATION_LIMIT } from './get-pagination-limit';

const updatePageInPagination = (query: string, page: number) => {
    return query.replace(
        /pagination:\s*\{([^}]*)\}/,
        (match, inner) => {
            // Change Page property
            if (/page\s*:/.test(inner)) {
                // Page exists – replace it
                const updatedInner = inner.replace(/(page\s*:\s*)\d+/, `$1${page}`);

                return `pagination: {${updatedInner}}`;
            }

            // Add page property if it doesn't exist
            const trimmed = inner.trim();
            const needsComma = trimmed.length > 0 && !trimmed.trim().endsWith(',');
            const separator = needsComma ? ', ' : '';

            return `pagination: {${trimmed}${separator}page: ${page}}`;
        }
    );
};

const fetchAllEntities = async (url: string, schema: string, entityName: string, config = {}, limit = PAGINATION_LIMIT) => {
    const paginatedSchema = updatePageInPagination(schema, 1);
    const entitiesBatch = await axios.post(url, { query: paginatedSchema }, config);
    const totalPages = Math.ceil(entitiesBatch?.data?.[entityName]?.[0]?._total / limit);

    console.log({
        entityName,
        config,
        totalPages
    });

    // All entities were got in the first request
    if (totalPages < 2) {
        return entitiesBatch;
    }

    const requests = [];

    for (let page = 2; page <= totalPages; page++) {
        const paginatedSchema = updatePageInPagination(schema, page);

        requests.push(axios.post(url, { query: paginatedSchema }, config));
    }

    console.log('Requests count: ', requests.length);

    const responses = await Promise.all(requests);

    const otherEntities = responses.flatMap(response => [...(response?.data?.[entityName] || [])]);

    entitiesBatch?.data?.[entityName].push(...otherEntities);

    return entitiesBatch;
};

export default fetchAllEntities;
